// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4761":"9624aa05b78f5447","6123":"9624aa05b78f5447","9969":"dd0a62dd2d0fa717"}[chunkId] + ".css";
};